import axios from '@/service/request';
import type { R, PlatformEnum } from './types';

/**
 * 三方免登请求参数
 */
export interface MiniAuthorizeRequest {
  /** 三方平台标识 */
  platform?: PlatformEnum;
}

/**
 * 三方免登响应数据
 */
export interface MiniAuthorizeResponse {
  /** ticket */
  ticket?: string;
}

/**
 * 三方免登(一次性ticket获取)
 */
export const apiAuthAuthorize = (data: MiniAuthorizeRequest): Promise<R<MiniAuthorizeResponse>> => {
  return axios.post('/auth/authorize', data);
};

